module.exports = __webpack_public_path__ + "img/paypal.f18c423.png";